import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'
import {fulfilled as fulfilledReadVersetzungsplanTermine} from './readVersetzungsplanTermine'

export function pending(state) {
  return {
    ...state,
    isLoadingTermine: true,
  }
}

export function fulfilled(state, payload, result) {
  return fulfilledReadVersetzungsplanTermine(state, payload, result)
}

export function rejected(state) {
  return {
    ...state,
    isLoadingTermine: false,
  }
}

export async function action(payload, state) {
  try {
    return await Api.createTerminAsAusbilder(
      payload,
      state.azubiIdsToLoadTermine ? state.azubiIdsToLoadTermine.join(',') : '',
    )
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
